// components/CompletionModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Progress, Row, Col } from 'reactstrap';
import campaignSuccess from "../assets/images/campaign-success.png"
import Image from './Image';

const CompletionModal = () => {
    const {
        showCompletionModal,
        completedTask,
        handleCompletionModalClose,
        tasks,
        progress,
        isCompleted
    } = useAppContext();
    const navigate = useNavigate();

    const handleBackToGetStarted = () => {
        handleCompletionModalClose();
        isCompleted ? navigate("/") : navigate('/get-started');
    };

    const getCompletionMessage = (taskId) => {
        const messages = {
            1: "Amazing! You've successfully created your first prompt. Now you can use this prompt to power your AI conversations.",
            2: "Excellent! Your agent is now ready. It will use your prompts to automate conversations and handle different scenarios.",
            3: "Fantastic! You've made your first call. Your agent is now ready to handle real conversations.",
            4: "Perfect! You've chosen your plan. You're all set to explore all the features of our platform."
        };
        return messages[taskId] || "Task completed successfully!";
    };
    const getCompletionHeading = (taskId) => {
        const heading = {
            1: "Prompt Creation Completed",
            2: "Agent Creation Completed",
            3: "Make Call Completed",
            4: "Plan Selection Completed"
        }
        return heading[taskId] || "Task completed successfully!";
    };

    const completedCount = tasks.filter(t => t.completed).length;
    const totalTasks = tasks.length;

    return (
        <Modal isOpen={showCompletionModal} toggle={handleCompletionModalClose} centered backdrop="static">
            <ModalBody>
                {completedTask && (
                    <>
                        <Row>
                            <Col md={12} className='text-center'>
                                <Image src={campaignSuccess} alt="Event" className='rounded-circle me-2' height='200px' width='200px' objectFit='cover' />
                                <h2>{getCompletionHeading(completedTask.id)}</h2>
                                <p>{getCompletionMessage(completedTask.id)}</p>
                            </Col>
                        </Row>
                        <Row className="text-center mt-3">
                            <Col>
                                <Button onClick={() => { handleBackToGetStarted() }} className="px-4 py-2 rounded linear-gradient-btn w-100">{isCompleted ? "Back to Dashboard" : "Back to Get Started"}</Button>
                            </Col>
                        </Row>
                    </>
                )}
            </ModalBody>
            {/* <ModalFooter>
                <Button color="secondary" onClick={handleCompletionModalClose}>
                    Continue Exploring
                </Button>
                <Button color="primary" onClick={handleBackToGetStarted}>
                    <i className="bi bi-house me-1"></i>
                    Back to Get Started
                </Button>
            </ModalFooter> */}
        </Modal>
    );
};

export default CompletionModal;